import { useState, useEffect } from "react";
import { amountNotWithDrawn } from "../../Api";
import { setTitlePage } from '../../Functions'

const AmountNotWithDrawn = () => {
  
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});

  const loadData = async () => {
    setLoading(true);
    const _response:any = await amountNotWithDrawn({});
    if (_response.status) {
      setData(_response.data);
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData();
    setTitlePage('Resumen de montos disponibles sin retirar');
  }, []);

  return (
    <>

      <div className="container" id="kt_docs_content_container">
        {loading && <p className="bg-light-primary text-primary p-3 fw-bold fs-3"
          style={{ width: 'fit-content', paddingLeft: '10px !important', paddingRight: '10px !important' }}>
            Cargando Datos... </p>}

        {!loading && data.montoantes !== undefined
          && data.montoantes.count <= 0
          && data.montodespues !== undefined
          && data.montodespues.count <= 0 && <p className="bg-light-primary text-primary p-3 fw-bold fs-3"
          style={{ width: 'fit-content', paddingLeft: '10px !important', paddingRight: '10px !important' }}>
            No existen montos sin retirar
          </p>}

        {!loading && data.montoantes !== undefined && data.montoantes.count > 0 &&
          <>
            <p className="fs-1 text-amsm">{data.montoantes.emisionbol}</p>
            <div className="card mb-10">
              <div className="card-body table-responsive">
                <table className="table table-row-bordered gy-7">
                  <thead className="fs-3 text-gray-400">
                    <tr>
                      <th style={{ padding: "10px" }}>Rut</th>
                      <th style={{ padding: "10px" }}>Razón Social</th>
                      <th style={{ padding: "10px" }}>Tipo de Pago</th>
                      <th style={{ padding: "10px" }}>Monto Factura o Boleta</th>
                      <th style={{ padding: "10px" }}>Fecha de Proceso</th>
                    </tr>
                  </thead>
                  <tbody className="fs-4 text-gray-700">
                    {data.montoantes.data.map((item:any, index:any) => (
                    <tr key={index}>
                      <td style={{ padding: "10px" }}>{item.rut}</td>
                      <td style={{ padding: "10px" }}>{item.razonsocial}</td>
                      <td style={{ padding: "10px" }}>{item.tipopago}</td>
                      <td style={{ padding: "10px" }}>${new Intl.NumberFormat("de-DE").format(item.montobruto)}</td>
                      <td style={{ padding: "10px" }}>{item.fechaproceso}</td>
                    </tr>))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        }

        {!loading && data.montodespues !== undefined && data.montodespues.count > 0 &&
          <>
            <p className="fs-1 text-amsm">{data.montodespues.emisionbol}</p>
            <div className="card">
              <div className="card-body table-responsive">
                <table className="table table-row-bordered gy-7">
                  <thead className="fs-3 text-gray-400">
                    <tr>
                    <th style={{ padding: "10px" }}>Rut</th>
                    <th style={{ padding: "10px" }}>Razón Social</th>
                    <th style={{ padding: "10px" }}>Tipo de Pago</th>
                    <th style={{ padding: "10px" }}>Monto Factura o Boleta</th>
                    <th style={{ padding: "10px" }}>Fecha de Proceso</th>
                    </tr>
                  </thead>
                  <tbody className="fs-4 text-gray-700">
                    {data.montodespues.data.map((item:any, index:any) => (
                    <tr key={index}>
                      <td style={{ padding: "10px" }}>{item.rut}</td>
                      <td style={{ padding: "10px" }}>{item.razonsocial}</td>
                      <td style={{ padding: "10px" }}>{item.tipopago}</td>
                      <td style={{ padding: "10px" }}>${new Intl.NumberFormat("de-DE").format(item.montobruto)}</td>
                      <td style={{ padding: "10px" }}>{item.fechaproceso}</td>
                    </tr>))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        }
      </div>

    </>
  );
}

export default AmountNotWithDrawn;
